import { useState } from "react";
import Reactportal from "../../../Reactportal/Reactportal";
import Input from "../../../Input/Input";
import PortalFooter from "../../../Reactportal/PortalFooter";

const VendorRemarks = ({ show, setShowModal, onhandleFormikChange, field, values }) => {
  const [open, setOpen] = useState(show);

  const Closeformfunction2 = () => {
    setShowModal();
    setOpen(false);
  };

  const submit = async () => {
    console.log("Remarks Submitted");
  };

  const SaveAndClose = () => {
    submit();
    Closeformfunction2();
  };
  return (
    <Reactportal open={open} onClose={Closeformfunction2} TypeOfPortal={"Remark"}>
      <div className="VendorRemarks">
        <div className="formContainer">
          <>
            <Input
              name={field.name}
              value={values?.[field.name]}
              label={field.label}
              type="text"
              modalform={true}
              handleInputChange={(e) => {
                onhandleFormikChange(e);
              }}
              handleBlur={() => {}}
              InputConfig={{
                autoFocus: true,
              }}
            />
          </>
        </div>
      </div>
      <PortalFooter
        renderContent={() => <></>}
        disabled={false}
        submitform={submit}
        SaveAndClose={SaveAndClose}
        handleformclose={() => {
          Closeformfunction2();
          setOpen(false);
        }}
      />
    </Reactportal>
  );
};

export default VendorRemarks;
